import { DecimalPipe, DatePipe } from '@angular/common';
import { Component, TemplateRef } from '@angular/core';
import { TableSummaryService } from './table-summary.service';
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from 'rxjs';
import { SummaryService } from '../summary/summary.service';
import { Output, EventEmitter } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { AccountService } from '../account/account.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-table-summary',
  templateUrl: './table-summary.component.html',
  styleUrls: ['./table-summary.component.scss'],
  providers: [TableSummaryService, DecimalPipe, DatePipe]
})
export class TableSummaryComponent {
  private transactionDetailsTpl!: TemplateRef<any>;
  public dataInitial!: NgbDateStruct;
  public dataFinal!: NgbDateStruct;
  public startDateIso?: string;
  public endDateIso?: string;
  public pad(n: number) { return String(n).padStart(2, '0'); }
  public nameColumn: string = '';
  public account: any;
  private langSub?: Subscription;
  langChangeSub!: Subscription;
  totalDepRequested = 0; totalDepTax = 0; totalDepSplit = 0; totalDepMoved = 0;
  totalSaqRequested = 0; totalSaqTax = 0; totalSaqSplit = 0; totalSaqMoved = 0;
  totalDepCount = 0;
  totalSaqCount = 0;

  transactionWithdrawDeposit: Array<{
    type: 'DEPOSITO' | 'SAQUE';
    origin: string | null;
    application: string | null;
    requestedValue: number;
    taxValue: number;
    split: number;
    movedValue: number;
    qtde: number;
  }> = [];

  @Output() loaded = new EventEmitter<void>();

  constructor(private summaryService: SummaryService, private accountService: AccountService, private translate: TranslateService) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());

    this.dataInitial = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() }
    this.dataFinal = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() }
  }

  ngOnInit(): void {
    this.getAccount();
    this.langSub = this.translate.onLangChange.subscribe(() => this.setTranslatedNameColumn());
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }

  private async getAccount(): Promise<void> {
    try {
      this.account = await this.accountService.getAccount();
      this.setTranslatedNameColumn();
    } catch (e) {
      this.nameColumn = this.translate.instant('common.split');
    }
  }

  private setTranslatedNameColumn(): void {
    this.translate.get(['common.license', 'common.split', 'common.reserve']).subscribe(t => {
      const raw = (this.account?.nameColumn || '').toString().toUpperCase();

      if (raw.includes('LICENCIADO')) {
        this.nameColumn = t['common.license'];
      } else if (raw.includes('RESERVA')) {
        this.nameColumn = t['common.reserve'];
      } else {
        this.nameColumn = t['common.split'];
      }
    });
  }


  public getTransactions() {
    let dateInitialFormat: string;
    let dateFinalFormat: string;

    if (this.startDateIso && this.endDateIso) {
      dateInitialFormat = this.startDateIso;
      dateFinalFormat = this.endDateIso;
    } else {
      const y1 = this.dataInitial.year, m1 = this.pad(this.dataInitial.month), d1 = this.pad(this.dataInitial.day);
      const y2 = this.dataFinal.year, m2 = this.pad(this.dataFinal.month), d2 = this.pad(this.dataFinal.day);
      dateInitialFormat = `${y1}-${m1}-${d1}T00:00:00`;
      dateFinalFormat = `${y2}-${m2}-${d2}T23:59:59`;
    }

    this.summaryService.getTransactionsExtrato(dateInitialFormat, dateFinalFormat,)
      .pipe(finalize(() => this.loaded.emit()))
      .subscribe({
        next: resp => {
          this.transactionWithdrawDeposit = resp.transactionWithdrawDeposit ?? [];

          this.totalDepRequested = this.totalDepTax = this.totalDepSplit = this.totalDepMoved = 0;
          this.totalSaqRequested = this.totalSaqTax = this.totalSaqSplit = this.totalSaqMoved = 0;
          this.totalDepCount = this.totalSaqCount = 0;


          for (const r of this.transactionWithdrawDeposit) {
            const qtd = Number(r.qtde) || 0;
            if (r.type === 'DEPOSITO') {
              this.totalDepRequested += r.requestedValue || 0;
              this.totalDepTax += r.taxValue || 0;
              this.totalDepSplit += r.split || 0;
              this.totalDepMoved += r.movedValue || 0;
              this.totalDepCount += qtd;
            } else {
              this.totalSaqRequested += r.requestedValue || 0;
              this.totalSaqTax += r.taxValue || 0;
              this.totalSaqSplit += r.split || 0;
              this.totalSaqMoved += r.movedValue || 0;
              this.totalSaqCount += qtd;
            }
          }
        },
        error: () => { this.transactionWithdrawDeposit = []; }
      });
  }

  mapApplication(application: string | null): string {
    if (!application) return '-';

    const app = application.toUpperCase();

    if (app === 'TEF') {
      return 'API';
    }

    if (app === 'TEFWEB') {
      return 'WEB';
    }
    
    return application;
  }


}



